/*
 * @Descripttion: 
 * @version: 
 * @Author: bbq
 * @Date: 2020-10-14 15:27:27
 * @LastEditors: bbq
 * @LastEditTime: 2020-12-18 16:54:30
 */
import { getDataFormatFromCache } from '@platform/api';

/**
 * 格式化数字 
 * @param {String} value 需要格式化的number字符串
 * return 返回格式化过的number字符串
 */
export function formatNumber(value) {
    if (!value) {return '';}
    let format = getDataFormatFromCache();
    if (!format || !format?.fm?.nfm) {
        console.warn('not find dataFormat');
        return value;
    }
    let formatNumber = format.fm.nfm;//数字格式
    // let red = formatNumber.negativeFormat.red ? true : false;
    let useMil = formatNumber.useMil ? true : false;
    let milSymbol = formatNumber.milSymbol || ',';
    let decimalSymbol = formatNumber.decimalSymbol || '.';
    let code = formatNumber.negativeFormat.code || '-n';
    let originalValue = String(value).replace(' ', '');//确保是字符串没空格
    let flag = false;//默认不是负数
    // 首先判断是不是负数
    if (originalValue.indexOf('-') !== -1) {
        originalValue = originalValue.replace('-', '');//先去掉负号
        flag = true;
    }
    let valueArray = originalValue.split('.');
    let integral = valueArray[0];//整数部分
    let decimals = '';//小数部分  默认没有
    if (valueArray.length > 1) {
        decimals = valueArray[1];
    }
    //如果不显示千分位
    if (!useMil) {
        integral = integral.replace(/,/g, '');
    } else {
        integral = integral.replace(/,/g, milSymbol);
    }
    let combination = integral;
    if (decimals !== '') { combination = combination + decimalSymbol + decimals; }
    //如果是负数按照负数显示格式设置
    if (flag) {
        combination = code.replace(/n/, combination);
    }
    return combination;
}